<script setup lang="ts">
import { PV } from "@/widgets";
import { isString } from "es-toolkit";
import { computed, ref, unref, type Component } from "vue";
import type { CreateDialog } from "../../common/button.common";

const props = defineProps<{
    controller: CreateDialog;
    icon: Component | string;
    label?: string;
}>();

defineSlots<{
    default: (data: { onClick: () => Promise<void> | void }) => any;
}>();

const dialogPopup = ref<{ toggle: (event: Event) => void; hide: () => void }>();
const isLoading = computed(() => {
    return unref(props.controller.isLoading) === true;
});

function toggleDialogPopup(event: Event) {
    dialogPopup.value?.toggle(event);
}

async function onClick() {
    dialogPopup.value?.hide();
    await props.controller.onClick();
}
</script>

<template>
    <PV.Button
        v-if="isString(props.icon)"
        v-tooltip.bottom="props.label"
        :disabled="isLoading"
        :icon="props.icon"
        severity="secondary"
        size="small"
        text
        type="button"
        @click="toggleDialogPopup"
    />
    <PV.Button
        v-else
        v-tooltip.bottom="props.label"
        :disabled="isLoading"
        severity="secondary"
        size="small"
        text
        type="button"
        @click="toggleDialogPopup"
    >
        <component :is="props.icon" />
    </PV.Button>

    <PV.Popover ref="dialogPopup">
        <div class="flex flex-col gap-3">
            <slot name="default" :onClick="onClick"></slot>
        </div>
    </PV.Popover>
</template>
